import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ColDef } from 'ag-grid-community';
import { ConfirmationMessageComponent } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/components/confirmation-message/confirmation-message.component';
import { SelectorComponent } from 'src/app/shared/components/sqp-components/sqpSelectores/components/selector/selector.component';
import { DatosExcel } from 'src/app/shared/ExportadorFicheros/models/datos-excel';
import { DatosPdf } from 'src/app/shared/ExportadorFicheros/models/datos-pdf';
import { ExportadorExcelService } from 'src/app/shared/ExportadorFicheros/services/exportador-excel.service';
import { ExportadorPdfService } from 'src/app/shared/ExportadorFicheros/services/exportador-pdf.service';
import { FiltroDocs } from 'src/app/shared/models/filtros';
import { GridColDefsDocs } from 'src/app/pages/configuracion/Envios/documentos/models/grid-col-defs-docs';
import { EstadosTipoDocumento, TipoDocumento } from 'src/app/pages/configuracion/Envios/documentos/models/tipo-documento';
import { DatosDocumentosService } from '../../services/datos-documentos.service';
import { DocumentosBarraSuperiorComponent } from '../documentos-barra-superior/documentos-barra-superior.component';
import { Router } from '@angular/router';
import { DatosConfiguracionDocumentosService } from '../../services/datos-configuracion-documentos.service';
import { TipoMensajeConfirmacion } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/models/confirmation-message-data';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { finalize } from 'rxjs/operators';
import { PaginationHelperService } from 'src/app/shared/services/pagination-helper.service';
import { FiltroSqp } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/filtro-sqp';
import { TipoFiltro } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/tipo-filtro';
import { DesplegableData } from 'src/app/shared/components/sqp-components/sqpDesplegable/models/desplegable-data';
import { SpinnerModalSqpComponent } from 'src/app/shared/components/sqp-components/sqpModales/spinner-modal-sqp/spinner-modal-sqp.component';
import { Observable } from 'rxjs';
import { FormularioDocumentoService } from '../../services/formulario-documento.service';

@Component({
  selector: 'app-documentos-page',
  templateUrl: './documentos-page.component.html',
  styleUrls: ['./documentos-page.component.css']
})
export class DocumentosPageComponent implements OnInit {

  documentosDatos: TipoDocumento[];
  textoBuscar: string = '';
  filtros: FiltroDocs[] = [];
  @ViewChild(DocumentosBarraSuperiorComponent) barrSuperior!: DocumentosBarraSuperiorComponent;
  verIncompletos: boolean = false;
  @ViewChild(SelectorComponent) selector!: SelectorComponent;
  columnDefs: ColDef[] = new GridColDefsDocs().columnDefs;
  currentPage = 1; // Current page number
  hasMoreRows = true; // Flag to check if more rows are available
  isLoading = false; // Prevent duplicate requests
  ordenColumna: OrdenColumna;
  newRows: TipoDocumento[] = [];
  dialogRefSpinner:any;
  gridSuppressSelectionEvents: boolean = false;
  docsFiltradosInput: TipoDocumento[] = [];
  filtrosSqpDocs: FiltroSqp[] = [];
  tipoDocsLista: DesplegableData[] = [];
  pageSizeDocs: number = 500;
  gridOptions:any={
    suppressScrollOnNewData: true
  }

  constructor(public datosDocumentosService: DatosDocumentosService,
              private _snackBar: MatSnackBar,
              private dialog: MatDialog,
              private exportadorPdfService: ExportadorPdfService,
              private exportadorExcelService: ExportadorExcelService,
              private router: Router,
              private datosConfiguracionDocumentosService: DatosConfiguracionDocumentosService,
              private formularioDocumentoService: FormularioDocumentoService) { }

  ngOnInit() {
  }

  getDocumentosData(){
    if (this.isLoading || !this.hasMoreRows) return;
    this.isLoading = true;
    const dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
    this.datosDocumentosService.getTipoDocumentos(this.filtrosSqpDocs, this.currentPage, this.pageSizeDocs, this.ordenColumna).subscribe({
      next: (resp) => {
        const newRows = resp;
        this.documentosDatos = [...(this.documentosDatos || []), ...newRows];
        this.currentPage++;
        const returnedRowCount = resp.length;
        if (returnedRowCount < this.pageSizeDocs) {
          this.hasMoreRows = false;
        }else this.hasMoreRows = true;
        dialogRefSpinner.close();
        this.isLoading = false;
      },
      error:  (error) => {
        dialogRefSpinner.close();
        this.isLoading = false;
        if(error.status!==401) this._snackBar.open(error.message, 'Cerrar',{duration: 4000})
       }
    })
  }

  clickBarraSuperior(id: string){
    switch (id) {
      case 'Excel':
        this.exportaExcel();
        break;
      case "Pdf":
        this.exportaPdf();
        break;
      default:
        break;
    }
  }

  configuraNuevoDocumento(){
    this.router.navigate(['/panel/nueva-configuracion-documento']);
  }

  async exportaPdf(){
    if(this.documentosDatos){
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-pdf-empty',
          titulo: 'Generar PDF',
          mensaje: '<p>Genera un documento PDF con la información de los registros mostrados en el listado</p>',
          textoConfirmacion: 'Generar PDF',
          iconoConfirmacion: 'icon-pdf-empty',
          textoCancelar: 'cancelar'
        }
      });

      //montamos el objeto a pasar al servicio con el modelo DatosPdf
      const datos = this.montarParametrosPdf();

      dialogRef.afterClosed().subscribe(result => {
        if(result === 'OK'){
          if(this.hasMoreRows){
            this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
            this.datosDocumentosService.getTipoDocumentos(this.filtrosSqpDocs, 0, 0, this.ordenColumna).subscribe({
              next: (response: any) => {
                this.documentosDatos=response;
                let docsExportar = [...this.documentosDatos];
                this.normalizarFirmantesNif(docsExportar);
                this.exportadorPdfService.exportaPdf(datos, docsExportar);
                this.dialogRefSpinner.close();
              },
              error: (error) => {
                console.error('Error loading rows:', error);
                this.dialogRefSpinner.close();
              }
            })
          }else{
            let docsExportar = [...this.documentosDatos];
            this.normalizarFirmantesNif(docsExportar);
            this.exportadorPdfService.exportaPdf(datos, docsExportar);
          }
        }
      });
    }
  }

  montarParametrosPdf(): DatosPdf{
    let columns: any [] = [];
    this.columnDefs.forEach( x => {
      columns.push( {header: x.headerName, dataKey: x.field} )
    })
    let fecha = new Date();
    let datosPdf = {
      landscape: true,
      nombreFichero:`Hire&Sign_documentos_configurados_${fecha.getFullYear()}${fecha.getMonth()+1}${fecha.getDate()}${fecha.getHours()}${fecha.getMinutes()}${fecha.getSeconds()}.pdf`,
      registros: columns
    }
    return datosPdf
  }

  exportaExcel(){
    if(this.documentosDatos){
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-excel-empty',
          titulo: 'Generar excel',
          mensaje: '<p>Genera un documento Excel con la información de los registros mostrados en el listado</p>',
          textoConfirmacion: 'Generar excel',
          iconoConfirmacion: 'icon-excel-empty',
          textoCancelar: 'cancelar'
        }
      });

      let datosExcel = this.montarParametrosExcel();

      dialogRef.afterClosed().subscribe(result => {
        if(result === 'OK'){
          if(this.hasMoreRows){
            this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
            this.datosDocumentosService.getTipoDocumentos(this.filtrosSqpDocs, 0, 0, this.ordenColumna).subscribe({
              next: (response: any) => {
                this.documentosDatos=response;
                let rows = this.GetRows(this.documentosDatos);
                this.exportadorExcelService.exportaExcel(datosExcel, rows);
                this.dialogRefSpinner.close();
                this.hasMoreRows = false;
              },
              error: (error) => {
                console.error('Error loading rows:', error);
                this.dialogRefSpinner.close();
              }
            })
          }else{
            let rows = this.GetRows(this.documentosDatos);
            this.exportadorExcelService.exportaExcel(datosExcel, rows);
          }
        }
      });
    }
  }

  montarParametrosExcel(): DatosExcel{
    let fecha = new Date();
    let datosExcel = {
      workSheetName:'Documentos',
      nombreFichero:`Hire&Sign_documentos_configurados_${fecha.getFullYear()}${fecha.getMonth()+1}${fecha.getDate()}${fecha.getHours()}${fecha.getMinutes()}${fecha.getSeconds()}.xlsx`,
      columnas: this.GetColumns()
    }
    return datosExcel
  }

  private GetColumns(): any[]{
    let columns:any[] = [];
    this.columnDefs.forEach( x => {
        let element:any = {};
        element.name = x.headerName;
        element.filterButton = true;
        element.width = x.width;
        columns.push(element);
    });
    return columns;
  }

  private GetRows(data: TipoDocumento[]): any{
    let rows:any[] = [];
    data.forEach((x:any)=>{//miramos si firmantesNif viene como array o está modificado a número porqué esta no es la primera vez en descargarse
      if(Array.isArray(x.firmantesNif)) x.firmantesNif=x.firmantesNif.length;
      else if (typeof x.firmantesNif == 'number') x.firmantesNif = x.firmantesNif;
      else x.firmantesNif = 0;
      let row:any[] =
      [
        x.nombre,
        x.paginas,
        x.firmantesNif,
        x.tipoDoc,
        // x.estado
      ];

      rows.push(row);
    });
    return rows
  }


  abrirDetallesDocumento(event:any){
    this.datosConfiguracionDocumentosService.transferirDocId(event.data);
    this.router.navigate([`/panel/editar-configuracion-documento`])
  }


  loadRows(){
    if (this.isLoading || !this.hasMoreRows) return;
    this.getDocumentosData();
  }

  ordenarGrid(event: OrdenColumna){
    this.ordenColumna = event;
    this.refreshData('ordenar')
  }

  refreshData(origen?:string){
    this.currentPage = 1;
    this.documentosDatos = [];
    this.hasMoreRows = true;
    this.getDocumentosData();
  }

  actualizarFiltrosDesdeFiltroSuperior(event:FiltroSqp){
    if(event){ //el evento puede venir undefined cuando se hace limpiar todo
      let index = this.filtrosSqpDocs.findIndex(x=>x.titulo==event.titulo)
      if(index == -1) this.filtrosSqpDocs.push(event);
      else this.filtrosSqpDocs[index] = event;
    }
    this.refreshData('filtros');
  }

  private normalizarFirmantesNif(docs: any[]): void {
    // Miramos si firmantesNif viene como array o está modificado a número porqué esta no es la primera vez en descargarse
    docs.forEach((x: any) => {
      if(Array.isArray(x.firmantesNif)) x.firmantesNif = x.firmantesNif.length;
      else if (typeof x.firmantesNif == 'number') x.firmantesNif = x.firmantesNif;
      else x.firmantesNif = 0;
    });
  }

}

